<template>
  <div class="col-12">
    <div class="row">
      <div class="col-12">
        <div class="pane-header">
          <span class="icon"><icon-colored-exchange /></span>
          <span class="text">{{ capitalize($t('names.dsp', { n: 2 })) }}</span>
        </div>
      </div>
      <div class="col-12">
        <div class="pane-content pad-top">
          <div class="d-lg-flex flex-row justify-content-between">
            <selectable-tiles
              :items="selectedBuyerExternalExchanges"
              :should-display-images="true"
              :should-display-labels="true"
              label-property-name="name"
              image-source-property-name="logoURL"
              :is-read-only="true" />
          </div>
          <span
            v-show="showMissingExternalExchanges"
            class="alert alert-warning mt-5">
            {{ capitalize(i18n.global.t('messages.someSelectedDSPsareMissing')) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
  import { capitalize, computed, onMounted } from 'vue';

  import SelectableTiles from '@/common/components/controls/SelectableTiles.vue';
  import { IconColoredExchange } from '@/common/icons/colored';
  import { Package } from '@/common/models';
  import { useExternalExchanges } from '@/org-app/services/tanstack/queries';
  import { waitForPendingQueries } from '@/org-app/services/tanstack/queryUtils';
  import i18n from '@/vueI18n';

  interface IDealDetailsExchangesProps {
    deal: Package;
  }

  const { deal } = defineProps<IDealDetailsExchangesProps>();

  const externalExchangesQuery = useExternalExchanges();

  const organizationExternalExchanges = computed(() => externalExchangesQuery.items.value);

  const selectedBuyerExternalExchanges = computed(() =>
    organizationExternalExchanges.value.filter((x) => deal.buyerExternalExchangeIDs.includes(x.externalExchangeID)),
  );

  const showMissingExternalExchanges = computed(() => {
    const organizationExternalExchangeIDs = organizationExternalExchanges.value.map((x) => x.externalExchangeID);
    return deal.buyerExternalExchangeIDs?.some((x) => !organizationExternalExchangeIDs.includes(x));
  });

  onMounted(async () => {
    await waitForPendingQueries([externalExchangesQuery]);
  });
</script>
